/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */ 

$(document).ready(function(){
    $('.cstm-add-to-cart-btn-cod-pro button').click(function (e) {
        e.preventDefault();
        $('.cstm-main-addtocartclick').trigger('click');
    });

    // brand section
    $('.cstm-toggle-btn-des').click(function (e) {
        e.preventDefault();
        var content = $('.cstm-brand-des-content');
        console.log(content.height());
        if(content.height() == 300){
            content.css("height", "100%");
            $(this).text('Read Less').addClass('cstm-read-less-btn').removeClass('cstm-read-more-btn');
            $('.cstm-brand-des-content').addClass('cstm-content-read-less-btn').removeClass('cstm-content-read-more-btn');
            $('.cstm-des-main-sec').addClass('cstm-content-main-read-less-btn').removeClass('cstm-content-main-read-more-btn');
        }else{
            content.css("height", "300px");
            $(this).text('Read More').addClass('cstm-read-more-btn').removeClass('cstm-read-less-btn');
            $('.cstm-brand-des-content').addClass('cstm-content-read-more-btn').removeClass('cstm-content-read-less-btn');
            $('.cstm-des-main-sec').addClass('cstm-content-main-read-more-btn').removeClass('cstm-content-main-read-less-btn');
        }
    });

    // alt value update
    $('body').find('img').each(function (e) {
        var alt = $(this).attr('alt');
        var get_imgur = $(this).attr('src');
        if (!alt){
            if(get_imgur){
                const parts = get_imgur.split('/');
                var lastPart = parts.pop();
                lastPart = lastPart.split('?')[0];
                if (lastPart.includes('.')) {
                    lastPart = lastPart.substring(0, lastPart.lastIndexOf('.'));
                }
                lastPart = lastPart.replace(/_/g, ' ').replace(/-/g, ' ');
                console.log(lastPart);
                $(this).attr('alt', lastPart);
            }else{
                $(this).attr('alt', 'This is an image');
                console.log('This is an image');
            }
        }
    });

    // Menu close
    $('.cstm-lexori-close-menu').click(function (e) {
        e.preventDefault();
        $('.HorizontalList__Item').removeClass('is-expanded');
        $('.MegaMenu--grid').attr('aria-hidden','true');
    });

    /* cstm add CASIO product on cart */
    $('.cstm_gm_2100_gsteel .custom-banner-button a').click(function (e) {
        e.preventDefault();
        $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            data: {id: 50264181309660,quantity: 1},
            dataType: 'json',
            success: function (data) {
                window.location.href = '/cart'
            },
            error: function (xhr, status, error) {
                console.log('Error:', error);
            }
        });
    });
    $('.cstm_ba110_bg_button .custom-banner-button a').click(function (e) {
        e.preventDefault();
        $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            data: {id: 50264194679004,quantity: 1},
            dataType: 'json',
            success: function (data) {
                window.location.href = '/cart'
            },
            error: function (xhr, status, error) {
                console.log('Error:', error);
            }
        });
    });

});


$(document).ready(function(){
  $('.slider-nav').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4000,
    focusOnSelect: true,
    prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0351/6370/1383/files/arrow-left_1.svg?v=1779085466" alt="Previous"></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0351/6370/1383/files/arrow-right-1.svg?v=1779085513" alt="Next"></button>'
  });
});
